import type { ClientKind } from '@/kinds/kind'
import { apply, defaults, displayName, initialStatus, validate } from './apply'
import { personSpec, personStatus, type PersonSpec, type PersonStatus } from './schema'

const Nothing = () => null

/** People are shown by views/People.tsx and the chips on tasks and dates. */
export const personKind: ClientKind<PersonSpec, PersonStatus> = {
  name: 'Person',
  version: 1,
  spec: personSpec,
  status: personStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  actions: [],
  ListRow: Nothing,
  Detail: Nothing,
  Form: Nothing,
  workspaceScoped: false,
}

export * from './schema'
export type { PersonResource } from './apply'
